import { ENTITY, ENTITY_TO_PATH_MAP } from './entity';

export const FUNNEL_ROUTE = `/${ENTITY_TO_PATH_MAP[ENTITY.FUNNEL]}`;
export const FUNNEL_ID_PARAM_NAME = 'funnelId';
export const FUNNEL_ID_PARAM_TEMPLATE = `/:${FUNNEL_ID_PARAM_NAME}?`;
